export const debugDeviceData = {
  deviceData: {
    information: {
      deviceManufacturer: 'Apple',
      deviceModelNumber: 'IPHONE',
      operatingSystem: 'Mac OS X',
      operatingSystemVersion: '10.15.7',
      browserType: 'Chrome',
      browserVersion: '92.0.4515.159',
    },
    geolocation: {
      ipGeolocation: {
        coordinates: '39.03,-77.49',
        city: 'ashburn',
        state: 'va',
        zip: '20147',
        country: 'usa',
      },
      gpsGeolocation: {
        coordinates: '49.41593358427357,32.06630620793315',
      },
    },
    observations: {
      firstSeen: '2021-xx-xx 21:09:54',
      lastSeen: '2021-xx-xx 20:06:53',
    },
    velocityMetrics: {
      historicalCount: {
        email: {
          uniqueCount: 3,
          uniqueSharePercent: 73,
        },
        mobileNumber: {
          uniqueCount: 3,
          uniqueSharePercent: 65,
        },
        surName: {
          uniqueCount: 3,
          uniqueSharePercent: 73,
        },
        firstName: {
          uniqueCount: 3,
          uniqueSharePercent: 73,
        },
      },
    },
  },
};
